import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react"
import { CabeceraTable } from "../../../../components/Table/CabeceraTable"
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent"
import { UseIncidenteTable } from "./UseIncidenteTable"
import IconHelper from "../../../../utils/helpers/iconHelper"
import { useBoolean } from "@fluentui/react-hooks";
import { IIncidenteDTO } from "../../../../Interfaces/hazard/IHazard"
import themeBase from "../../../../utils/theme/themeBase"
import { useState } from "react"
import { PanelNuevoIncidente } from "./nuevoIncidente/PanelNuevoIncidente"
import { PanelEditarIncidente } from "./editarIncidente/PanelEditarIncidente"
import { PanelOcultoIncidente } from "./ocultoIncidente/PanelOcultoIncidente"

export const IncidenteTable=()=>{
    const { items, filter, setFilter, loading, pagination, onChangeSearch, getIncidentes, handleResetUpdate, onChangeTake, _onkeyUpSearchTable } = UseIncidenteTable()
    const [isOpenEditar, { setTrue: openPanelEditar, setFalse: closePanelEditar }] = useBoolean(false);
    const [isOpenNuevo, { setTrue: openPanelNuevo ,setFalse: closePanelNuevo }] = useBoolean(false);
    const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);
    const [item, setItem] = useState<IIncidenteDTO>({
        grupoIncidenteId: "",
        nombreGrupoIncidente: "",
        codigoGrupoIncidente: "",
        esOculto:false
    })

    const buttonLeft: ICommandBarItemProps[] = [
         {
           ...IconHelper.ICON_ADD_TABLE,
           text: "Nuevo",
           onClick: openPanelNuevo,
        },
        {
          ...IconHelper.ICON_RELOAD,
          text: "Actualizar",
          onClick: () => {
            handleResetUpdate()
          },
        }
      ];
      const _columns = [
        {
          key: "nombreGrupoIncidente",
          name: "Incidente",
          fieldName: "nombreGrupoIncidente",
          minWidth: 100,
          maxWidth: 300,
        },
        {
          key: "codigoGrupoIncidente",
          name: "Codigo",
          fieldName: "codigoGrupoIncidente",
          minWidth: 100,
          maxWidth: 300,
        },
        {
            key: "opciones",
            name: "Opciones",
            minWidth: 100,
            maxWidth: 300,
            onRender: (item: IIncidenteDTO) => renderOpciones(item)
          }
         ]
        function renderOpciones(item: IIncidenteDTO) {
            return (
                <>
                  <TooltipHost content={"Editar"}>
                    <Icon
                      iconName="Edit"
                      className={themeBase.classNamesIcon.iconFont}
                      style={{ cursor: "pointer", color: "#0078d3" }}
                      onClick={() => {
                        setItem(item)
                        openPanelEditar()
                      }}
                    />
                  </TooltipHost>
                  {item.esOculto ? (<TooltipHost content={"Integrar"}>
                     <Icon
                       iconName="Add"
                       className={themeBase.classNamesIcon.iconFont}
                       style={{ cursor: "pointer", color: "#0078d3" }}
                       onClick={() => {
                         setItem(item)
                         openPanelEliminar()
                       }}
                     />
                  </TooltipHost>):(
                     <TooltipHost content={"Ocultar"}>
                     <Icon
                       iconName="Delete"
                       className={themeBase.classNamesIcon.iconFont}
                       style={{ cursor: "pointer", color: "#0078d3" }}
                       onClick={() => {
                         setItem(item)
                         openPanelEliminar()
                       }}
                     />
                   </TooltipHost>
                  )}
                 
                </>
              );
        }

    return (
        <>
         <CabeceraTable
        Titulo={"Incidentes"}
        SubTitulo={"Gestión de Incidentes"}
        onKeyUp={_onkeyUpSearchTable}
        />
        <TableBaseComponent
        leftBar={buttonLeft}
        rigthBar={[]}
        data={items}
        column={_columns}
        isLoading={loading}
        getPageSize={onChangeTake}
        pagination={pagination}
        layout={DetailsListLayoutMode.justified}
        tableSiza
        />
        <PanelNuevoIncidente isOpen={isOpenNuevo} onDismiss={closePanelNuevo} reload={handleResetUpdate}/>
        <PanelEditarIncidente item={item} isOpen={isOpenEditar} onDismiss={closePanelEditar } reload={handleResetUpdate}/>
        <PanelOcultoIncidente item={item} isOpen={isOpenEliminar} onDismiss={closePanelEliminar } reload={handleResetUpdate}/>
        </>
    )
}